import { useState } from 'react';

const PERGUNTAS = [
  {
    id: 'escavacao',
    label: 'Escavação',
    descricao: 'Tipo de escavação para fundações',
    opcoes: ['Manual', 'Máquina'],
  },
  {
    id: 'chapisco',
    label: 'Chapisco',
    descricao: 'Método de aplicação do chapisco',
    opcoes: ['Manual', 'Projetado'],
  },
  {
    id: 'concreto',
    label: 'Concreto',
    descricao: 'Tipo de fornecimento do concreto',
    opcoes: ['Usinado', 'Virado em obra'],
  },
  {
    id: 'lancamento',
    label: 'Lançamento do Concreto',
    descricao: 'Método de lançamento',
    opcoes: ['Bomba', 'Jerica'],
  },
  {
    id: 'adensamento',
    label: 'Adensamento',
    descricao: 'Equipamento de adensamento',
    opcoes: ['Vibrador', 'Manual'],
  },
];

function TabMetodo() {
  const [respostas, setRespostas] = useState({});
  const [calculado, setCalculado] = useState(false);

  const handleSelect = (perguntaId, opcao) => {
    setRespostas((prev) => ({ ...prev, [perguntaId]: opcao }));
    setCalculado(false);
  };

  const todasRespondidas = PERGUNTAS.every((p) => respostas[p.id]);

  const handleCalcular = () => {
    setCalculado(true);
  };

  return (
    <div className="p-4 md:p-8">
      <h2 className="text-xl font-bold text-gray-900 mb-2">Método Executivo</h2>
      <p className="text-gray-500 mb-8">
        Selecione as opções para cada etapa da obra
      </p>

      <div className="space-y-4">
        {PERGUNTAS.map((pergunta) => (
          <div
            key={pergunta.id}
            className={`
              p-5 rounded-xl border-2 transition-all duration-200
              ${respostas[pergunta.id]
                ? 'border-orca-200 bg-orca-50/30'
                : 'border-gray-100 bg-gray-50/50'
              }
            `}
          >
            <div className="flex flex-col sm:flex-row sm:items-center gap-4">
              {/* Checkbox + Label */}
              <div className="flex items-center gap-3 flex-1">
                <div
                  className={`
                    w-6 h-6 rounded-md border-2 flex items-center justify-center flex-shrink-0
                    ${respostas[pergunta.id]
                      ? 'bg-orca-600 border-orca-600'
                      : 'border-gray-300'
                    }
                  `}
                >
                  {respostas[pergunta.id] && (
                    <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                    </svg>
                  )}
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-lg">{pergunta.label}</p>
                  <p className="text-sm text-gray-400">{pergunta.descricao}</p>
                </div>
              </div>

              {/* Options */}
              <div className="flex gap-2 ml-9 sm:ml-0">
                {pergunta.opcoes.map((opcao) => (
                  <button
                    key={opcao}
                    onClick={() => handleSelect(pergunta.id, opcao)}
                    className={`
                      px-5 py-2.5 rounded-lg font-medium text-sm transition-all duration-200 cursor-pointer
                      ${respostas[pergunta.id] === opcao
                        ? 'bg-orca-800 text-white shadow-md'
                        : 'bg-white text-gray-600 border border-gray-200 hover:border-orca-300 hover:text-orca-700'
                      }
                    `}
                  >
                    {opcao}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Botão Calcular */}
      <button
        onClick={handleCalcular}
        disabled={!todasRespondidas}
        className={`
          mt-8 w-full py-5 rounded-2xl text-xl font-bold transition-all duration-200 cursor-pointer
          ${todasRespondidas
            ? 'bg-orca-800 text-white hover:bg-orca-700 shadow-lg shadow-orca-800/20'
            : 'bg-gray-200 text-gray-400 cursor-not-allowed'
          }
        `}
      >
        Calcular
      </button>

      {/* Resultado */}
      {calculado && (
        <div className="mt-6 p-6 bg-green-50 border border-green-200 rounded-xl">
          <div className="flex items-center gap-3 mb-3">
            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            <p className="text-lg font-bold text-green-800">Cálculo concluído!</p>
          </div>
          <p className="text-green-700 ml-9">
            Método executivo configurado. Vá até a aba <strong>Download</strong> para baixar o orçamento completo.
          </p>
        </div>
      )}
    </div>
  );
}

export default TabMetodo;
